import { dataReportStampSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportStampSolid = /*#__PURE__*/createIcon(dataReportStampSolid)
export default IconReportStampSolid
